// eslint-disable-next-line no-shadow
export enum GlobalAlertTypes {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}

export interface GlobalAlert {
  id?: number;
  text: string;
  type: GlobalAlertTypes;
  timed?: boolean;
  dismissible?: boolean;
}

export interface AlertsState {
  globalAlerts: Array<GlobalAlert>;
}

export interface AlertsPlugin {
  add: (alert: GlobalAlert) => GlobalAlert;
  remove: (alertId: number) => void;
}
